import React, { createContext, useContext } from 'react';
import { useObdGoogleStreetView } from './useObdGoogleStreetView';

type ObdGoogleStreetViewContextValue = {
    openFromRoot: (root: unknown) => Promise<void>;
    loading: boolean;
};

const ObdGoogleStreetViewContext = createContext<ObdGoogleStreetViewContextValue | null>(null);

/** When outside {@link ObdGoogleStreetViewProvider}, returns null (caller may use a local hook). */
export function useObdGoogleStreetViewOptional(): ObdGoogleStreetViewContextValue | null {
    return useContext(ObdGoogleStreetViewContext);
}

export function ObdGoogleStreetViewProvider({
    theme,
    children,
}: {
    theme: 'dark' | 'light';
    children: React.ReactNode;
}) {
    const { openFromRoot, streetViewModal, loading } = useObdGoogleStreetView(theme);

    return (
        <ObdGoogleStreetViewContext.Provider value={{ openFromRoot, loading }}>
            {children}
            {streetViewModal}
        </ObdGoogleStreetViewContext.Provider>
    );
}

export function useObdGoogleStreetViewActions(): ObdGoogleStreetViewContextValue {
    const ctx = useContext(ObdGoogleStreetViewContext);
    if (!ctx) {
        throw new Error('useObdGoogleStreetViewActions must be used within ObdGoogleStreetViewProvider');
    }
    return ctx;
}
